module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_alert.6903adb0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_alert.png
// module id = 1044
// module chunks = 16